module.exports = __webpack_public_path__ + "img/news_bg.b892645e.png";